import React from 'react'
import './index.less'
import { Toast, Modal } from 'antd-mobile'
import { device, setLogin, isEmpty, getParams } from '../../../assets/js/utils'
import BandCardStatusDialog from './../BandCardStatusDialog/index'
import request from '@/assets/js/request'
import doubtImg from './../../../assets/images/doubt.png'
import bankYkImg from './../../../assets/images/bankYk.png'

function closest (el, selector) {
    const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector
    while (el) {
        if (matchesSelector.call(el, selector)) {
            return el
        }
        el = el.parentElement
    }
    return null
}

class CardYika extends React.Component {
    constructor () {
        super()
        this.state = {
            isLogin: false,
            confirmText: '您未绑定银行卡，请完成绑定',
            showDialog: false, // 白条绑卡的状态
            isBtn: true,
            businessLine: '', // 业务线
            doubtDialog: false,
            jumpDialog: false, // 易卡跳转弹框
            doubtModalInfo: {
                rateParaphraseContent: '当前利率仅供参考，具体以提现页展示的年化综合融资成本(单利)信息为准'
            }
        }
    }

    componentDidMount () {
        const { sublist = [] } = this.props.data
        const item = sublist[0]
        if (device.isGomePlus) {
            window.GomeJSBridge.isLogin((data) => {
                if (data.isLogined === 'Y') {
                    this.setState({
                        isLogin: true
                    }, () => this.isEntrySwitch(item))
                } else {
                    this.setState({ isLogin: false })
                }
            })
        }
    }

    componentWillUnmount () {
        localStorage.removeItem('data')
    }

    checkBindCardStatus = (item) => {
        // 白条原有逻辑未动
        if (item.accountStatus === '052') { // 已开通
            if (item.bindCardState === '010') { // 已绑卡 查看绑卡状态
                if (item.cardState !== '0') {
                    this.setState({
                        confirmText: '您的默认银行卡信息已过期，请重新绑定',
                        showDialog: true,
                        isBtn: true
                    })
                }
            } else if (item.bindCardState === '020') { // 已开通 未绑卡
                this.setState({
                    confirmText: '您未绑定银行卡，请完成绑定',
                    showDialog: true,
                    isBtn: true
                })
            }
        } else if (item.accountStatus === '053') { // 开通失败
            if (item.bindCardState === '010') { // '010'已绑卡
                // 未激活 已绑卡 查看绑卡状态
                this.queryBankCard(item)
            }
        } else { // 未开通
            if (item.bindCardState === '010') { // '010'已绑卡
                // 未激活 已绑卡 查看绑卡状态
                this.queryBankCard(item)
            }
        }
    }

    queryBankCard = (item) => { // 查看绑卡状态
        if (item.cardState !== '0') {
            this.setState({
                confirmText: '您的默认银行卡信息已过期，请重新绑定',
                isBtn: true,
                showPlusMyAssetDialog: false,
                showDialog: true
            })
        }
    }

    handleShowDialog = () => {
        this.setState({
            showDialog: !this.state.showDialog
        })
    }

    checkStatus = (item) => {
        const { isLogin } = this.state
        const isFrozen = item.amountStatus === '020' || item.amountStatus === '030'
        if (isLogin) {
            if (item.accountStatus === '052') {
                if (item.amountStatus === '010') { // 白条额度状态 010：可用
                    if (item.bindCardState === '010') { // 是否已绑卡{010：是}
                        if (item.cardState !== '0') {
                            this.setState({
                                confirmText: '您的默认银行卡信息已过期，请重新绑定',
                                isBtn: true,
                                // showPlusMyAssetDialog: false,
                                showDialog: true
                            })
                            return
                        }
                        if (item.quotaInfoResCode === '0000') {
                            if (item.quotaInfoHasMobile === '0') {
                                this.setState({
                                    confirmText: '您的账户尚未绑定手机号，请前往“我的”--＞“设置”--＞“账户安全”--＞“手机验证”进行绑定。',
                                    isBtn: false,
                                    // showPlusMyAssetDialog: false,
                                    showDialog: true
                                })
                            } else if (item.quotaInfoHasMobile === '1') {
                                if (item.quotaInfoFlag === '0') {
                                    window.GomeJSBridge.pushWindow(null, null, `${process.env.REACT_APP_MEIYIFEN_HTML}dist/borrow.html?isFrozen=${isFrozen}`)
                                } else {
                                    switch (item.quotaInfoFlag) {
                                    case '14':
                                        window.GomeJSBridge.pushWindow(null, null, `${process.env.REACT_APP_MEIYIFEN_HTML}dist/authen.html?toPage=borrow`)
                                        break
                                    default:
                                        Toast.info(`${item.quotaInfoResDesc}`, 1)
                                    }
                                }
                            }
                        } else {
                            Toast.info(`${item.quotaInfoResDesc}`, 1)
                        }
                    } else if (item.bindCardState === '020') { // 是否已绑卡{020：否}
                        this.setState({
                            confirmText: '您未绑定银行卡，请完成绑定',
                            isBtn: true,
                            // showPlusMyAssetDialog: false,
                            showDialog: true
                        })
                    }
                } else if (item.amountStatus === '020') { // 白条额度状态 020：冻结；
                    Toast.info('您的易卡已处于永久冻结状态，无法进行易卡消费', 1)
                } else if (item.amountStatus === '030') { // 白条额度状态 030：临时冻结
                    Toast.info('您的易卡已处于临时冻结状态，无法进行易卡消费', 1)
                }
            } else if (item.accountStatus === '053') { // 开通失败 说明原因
                window.GomeJSBridge.pushWindow(null, null, `${process.env.REACT_APP_MEIYIFEN_HTML}dist/openresult.html`)
            } else { // 未开通 去开通
                this.opencount(item)
            }
        } else { // 未登录时 去登录
            setLogin()
        }
    }

    opencount = (item) => {
        if (item.hasPlusMobile === '020') {
            this.setState({
                confirmText: '请先至 设置--＞账户安全--＞手机验证处补充注册手机号，再进行额度激活操作',
                isBtn: false,
                //  showPlusMyAssetDialog: false,
                showDialog: true
            })
            return
        }
        if (item.allowOpen === '010') {
            window.GomeJSBridge.pushWindow(null, null, `${process.env.REACT_APP_MEIYIFEN_HTML}dist/index.html`)
        } else {
            window.GomeJSBridge.pushWindow(null, null, `${process.env.REACT_APP_MEIYIFEN_HTML}dist/noopen.html`)
        }
    }

    noSlide = () => {
        const { slide } = this.state
        if (slide) {
            document.body.style.position = 'fixed'
            document.body.style.width = '100%'
        } else {
            document.body.style.position = 'static'
        }
    }

    // 绑定银行卡
    tobind = () => {
        window.GomeJSBridge.pushWindow(null, null, `${process.env.REACT_APP_MEIYIFEN_HTML}dist/bankcard.html?from=pay&fromIndex=true&cert=true`)
    }

    // 处理可售额度 千分符 100,000
    handleNum = (num) => {
        num = isEmpty(num) ? '' : num.toString()
        const AMOUNT_REG = /(\d)(?=(?:(\d{3})|\d{3}\.\d+)+$)/g
        return num.replace(AMOUNT_REG, '$1,')
    }

    // 处理判断逻辑
    isEntrySwitch (item) {
        if (item.businessLine === '0907') {
            // 初始化易卡流程逻辑
            this.handleEasyCardInit(item)
        } else {
            console.log(window.GomeJSBridge.appVersion, '版本号')
            if (window.GomeJSBridge.appVersion <= 170) Toast.info('请您更新使用国美APP V7.0.5及以上版本', 1)
            this.checkBindCardStatus(item)
        }
    }
    // 白条渲染 原有逻辑未动

    whiteNoteRender (item, index) {
        const { buriedPointEvent, data: { position, trackId, style = {} } } = this.props
        const {
            btnBackgroundPicUrl,
            btnBackgroundColor,
            btnTextColor
        } = style
        const { isLogin } = this.state
        const account5053 = !isLogin || item.accountStatus === '050' || item.accountStatus === '053'
        const account52 = isLogin && item.accountStatus === '052'
        return (
            <div>
                <p className={'cardYikaContent'}>{this.sortOutTitle(item)}</p>
                <p className={'cardYikaContent cardYikaContentLast'}>{item.publicityText}</p>
                <div className={'cardYikaCenter'}>
                    { account5053 && (<span>{this.handleNum(parseInt(item.content))}</span>) }
                    {account5053 && (
                        <span
                            style={{
                                backgroundColor: btnBackgroundColor || '',
                                backgroundImage: btnBackgroundPicUrl ? `url(${btnBackgroundPicUrl})` : '',
                                color: btnTextColor || ''
                            }}
                            onClick={() => {
                                buriedPointEvent({
                                    button_name: `${trackId}-立即申请额度`,
                                    button_id: `${item.id}`,
                                    button_order: `${index + 1}`,
                                    area_order: position,
                                    button_area: `${position}-${trackId}`
                                })
                                this.checkStatus(item)
                            }}
                            className={'statistics-dom'}
                        >立即申请额度</span>
                    )}
                    {account52 && (<span>{this.handleNum(parseInt(item.availableAmount))}</span>) }
                    {account52 && (
                        <span
                            className={'statistics-dom'}
                            style={{
                                backgroundColor: btnBackgroundColor || '',
                                backgroundImage: btnBackgroundPicUrl ? `url(${btnBackgroundPicUrl})` : '',
                                color: btnTextColor || ''
                            }}
                            onClick={() => {
                                buriedPointEvent({
                                    button_name: `${trackId}-立即提现`,
                                    button_id: `${item.id}`,
                                    button_order: `${index + 1}`,
                                    area_order: position,
                                    button_area: `${position}-${trackId}`
                                })
                                this.checkStatus(item)
                            }}
                        >立即提现</span>
                    ) }
                </div>
                {item.accountStatus === '052' && item.expressiveAmount && (
                    <p
                        className={'cardYikaQuota statistics-dom'}
                        onClick={() => {
                            localStorage.setItem('data', JSON.stringify(item))
                            window.GomeJSBridge.pushWindow(null, null, window.location.origin + '/activity/plusMyAssetDialog')
                        }}
                    >
                        <span>提现额度{this.handleNum(parseInt(item.expressiveAmount))}</span>
                        <span />
                    </p>
                )}
                {item.cuePhrases && account5053 && (
                    <p className={'cardYikaTip'} >
                        {item.cuePhrases}
                    </p>
                )}
            </div>

        )
    }

    // 易卡
    easyCardRender (item, index) {
        const { data: { position, trackId }, buriedPointEvent } = this.props
        return (
            <div>
                <p className={'cardYikaContent'}>
                    {item.annualizedInterestRateText}
                    {/* {
                        `${item.rateParaphraseFlag}` === '1' && <i className="doubtIcon" onClick={() => { this.setState({ doubtModalVis: true, doubtModalInfo: item }) }}></i>
                    } */}
                </p>
                <p className={'cardYikaContent cardYikaContentLast'}>
                    {item.publicityText}
                    {
                        item.tipsFlag === '1' ? <img
                            className={'doubtLogo'}
                            onClick={() => { this.setState({ doubtDialog: true }) }}
                            src={doubtImg}
                            alt="" /> : undefined
                    }

                </p>
                <Modal
                    visible={this.state.doubtDialog}
                    transparent
                    maskClosable={false}
                    onClose={() => {
                        this.setState({ doubtDialog: false })
                    }}
                    title="额度说明"
                    footer={[]}
                    className="cardYikaModal"
                >
                    <div className="content">
                        {item.tipsContent}
                        {/* 该额度是由博盛安融(天津)融资担保有限公司提供的担保额度，成功获得担保额度并不意味着一定成功借款。 */}
                    </div>
                    <p className="doubtModalBtn" onClick={() => this.setState({ doubtDialog: false })}>知道了</p>
                </Modal>
                <div className={'cardYikaCenter'}>
                    <span>{this.quotaSortOut(item)}</span>
                    <span
                        className={'statistics-dom'}
                        style={this.sortOutStyle(item)}
                        onClick={() => {
                            buriedPointEvent({
                                button_name: `${trackId}-${this.sortOutbuttonText(item)}`,
                                button_id: `${item.id}`,
                                button_order: `${index + 1}`,
                                area_order: position,
                                button_area: `${position}-${trackId}`
                            })
                            this.handleClockEasyCard(item)
                        }}>
                        {this.sortOutbuttonText(item)}
                    </span>
                </div>
                <p className={'cardYikaTip'} >
                    {item.cuePhrases}
                </p>
                <Modal
                    visible={this.state.jumpDialog}
                    transparent
                    maskClosable={false}
                    className="cardYikaModal"
                >
                    <div className={'cardYikajumpDialog'}>
                        <img src={bankYkImg} />
                        <div className={'cardYikajumpDialog_test'}>
                        您的信用贷额度已过期,请尽快完成续期,避免影响后续交易,感谢您的理解与支持!
                        </div>
                        <div className={'cardYikajumpDialog_btn'} onClick={
                            () => {
                                this.dealIdJump(item)
                            }
                        }>立即续期</div>
                        <div className={'cardYikajumpDialog_btn_close'} onClick={
                            () => {
                                this.setState({ jumpDialog: false })
                            }
                        }>暂不续期</div>
                    </div>
                </Modal>
            </div>
        )
    }

    onWrapTouchStart = (e) => {
        // fix touch to scroll background page on iOS
        if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
            return
        }
        const pNode = closest(e.target, '.am-modal-content')
        if (!pNode) {
            e.preventDefault()
        }
    }

    // 整理 易卡 button文字
    sortOutbuttonText (item) {
        return item.buttonText ? item.buttonText : '立即申请额度'
    }

    // 易卡点击事件
    handleClockEasyCard (item) {
        console.log('打印点击按钮跳转的数据', item.quotaStatus, typeof item.quotaStatus)
        const { isLogin } = this.state
        // 判断是否登录
        if (isLogin) {
            if (item.quotaStatus !== '1' && item.quotaStatus !== '6') {
                Toast.info(item.toastMsg, 1)
                return
            }
            if (item.quotaStatus === '6') {
                this.setState({
                    jumpDialog: true
                })
                return
            }
            const headers = {
                businessLine: getParams().source === 'plus' ? '0917' : '2048'
            }
            request.get('/gateway/v1/yk/creditInfo/beforeCheck', { headers }).then(res => {
                const { access, resultMsg, resultCode } = res.data
                // 登录
                if (resultCode === '0008') return setLogin()
                if (access === 'true') {
                    const { url } = item
                    if (isEmpty(url)) return Toast.info('跳转异常，请联系工作人员', 1)
                    window.GomeJSBridge.pushWindow(null, null, item.url)
                    // const jump = activeStatus === 'U' ||
                    // activeStatus === 'B' ||
                    // activeStatus === 'BN' ||
                    // activeStatus === 'S' ||
                    // activeStatus === 'F' ||
                    // activeStatus === 'N'
                    // if (jump) {
                    //     if (isEmpty(url)) return Toast.info('跳转异常，请联系工作人员', 1)
                    //     window.GomeJSBridge.pushWindow(null, null, item.url)
                    // } else if (activeStatus === 'P') {
                    //     Toast.info('请等待审批结果', 1)
                    // } else {
                    //     Toast.info('状态异常，请联系工作人员', 1)
                    // }
                } else {
                    Toast.info(resultMsg, 1)
                }
            })
        } else {
            setLogin()
        }
    }

    // 处理卡片跳转
    dealIdJump (item) {
        const { url } = item
        console.log('进入跳转6666', item.url)
        if (isEmpty(url)) return Toast.info('跳转异常，请联系工作人员', 1)
        window.GomeJSBridge.pushWindow(null, null, item.url)
    }

    // 初始化易卡逻辑
    handleEasyCardInit () {
    }

    // 整理title
    sortOutTitle (item) {
        return <React.Fragment>
            <b>{item.productName}</b>
            <b style={{ margin: '0 5px' }}>·</b>
            {item.annualizedInterestRateText}
            {
                `${item.rateParaphraseFlag}` === '1' && <i
                    className="doubtIcon"
                    onClick={() => {
                        this.setState({ doubtModalVis: true, doubtModalInfo: item })
                    }}
                ></i>
            }

        </React.Fragment>
    }

    // 额度整理
    quotaSortOut (item) {
        const { isLogin } = this.state
        const quota = isLogin ? item.availableAmount : item.content
        return this.handleNum(quota)
    }

    // 整理样式
    sortOutStyle (item) {
        return {
            backgroundColor: item.btnBackgroundColor || '',
            backgroundImage: item.btnBackgroundPicUrl ? `url(${item.btnBackgroundPicUrl})` : '',
            color: item.btnTextColor || ''
        }
    }

    // 渲染业务线类型remder
    isBusinessLineSwitchRender (item, index) {
        switch (item.businessLine) {
        case '0907':
            return this.easyCardRender(item, index)
        case '0931' :
            return this.whiteNoteRender(item, index)
        }
    }

    render () {
        const { id, position, trackId, style = {}, sublist = [] } = this.props.data
        const {
            cardBackgroundPicUrl,
            cardBackgroundColor,
            paddingTop
        } = style

        const { showDialog, confirmText, isBtn, doubtModalVis, doubtModalInfo } = this.state
        // 当前业务线
        return (
            <React.Fragment>
                {sublist.map((item, index) => {
                    return (
                        <div className={'cardYikaContainer'} key={index} style={{
                            background: cardBackgroundPicUrl ? `url(${cardBackgroundPicUrl}) no-repeat` : cardBackgroundColor,
                            backgroundSize: '100% 100%',
                            marginTop: `${paddingTop ? paddingTop / 75 : 0}rem`
                        }}>
                            {this.isBusinessLineSwitchRender(item, index)}
                            {item.iconUrl ? (<span className={'rightTopIcon'} style={{ backgroundImage: `url(${item.iconUrl})` }}></span>) : null}
                        </div>
                    )
                })}
                {showDialog && <BandCardStatusDialog
                    confirmText={confirmText}
                    handleShowDialog={this.handleShowDialog}
                    tobind={this.tobind}
                    isBtn={isBtn}
                    id={id}
                    position={position}
                    trackId={trackId}
                    title={sublist[0].title}
                />}

                <Modal
                    visible={doubtModalVis}
                    transparent
                    maskClosable={false}
                    onClose={() => {
                        this.setState({ doubtModalVis: false })
                    }}
                    title={'年化综合融资成本(单利)'}
                    footer={[]}
                    className="cardYikaModal"
                >
                    <div className="content">
                        {doubtModalInfo.rateParaphraseContent}
                    </div>
                    <p className="doubtModalBtn" onClick={() => this.setState({ doubtModalVis: false })}>知道了</p>
                </Modal>
            </React.Fragment>

        )
    }
}

export default CardYika
